module.exports = __webpack_public_path__ + "img/play.7f9f1e8a.svg";